import { translate } from '../L10n';
import { t } from '../../translations';
import productService from './index';
const articles = {};

function getSections() {
  const cm = translate(t.MEASURE_VALUE_CM);
  return {
    section_84x54x190: {
      measureReference: {
        textMetric: `190x85 ${cm}`,
        textImperial: '74 3/4x33 1/2 "',
      },
    },
    section_84x39x190: {
      measureReference: {
        textMetric: `190x85 ${cm}`,
        textImperial: '74 3/4x33 1/2 "',
      },
    },
    section_64x54x190: {
      measureReference: {
        textMetric: `190x65 ${cm}`,
        textImperial: '74 3/4x25 5/8 "',
      },
    },
    section_64x39x190: {
      measureReference: {
        textMetric: `190x65 ${cm}`,
        textImperial: '74 3/4x25 5/8 "',
      },
    },
    section_84x54x110: {
      measureReference: {
        textMetric: `110x85 ${cm}`,
        textImperial: '43 1/4x33 1/2 "',
      },
    },
    section_84x39x110: {
      measureReference: {
        textMetric: `110x85 ${cm}`,
        textImperial: '43 1/4x33 1/2 "',
      },
    },
    section_64x54x110: {
      measureReference: {
        textMetric: `110x65 ${cm}`,
        textImperial: '43 1/4x25 5/8 "',
      },
    },
    section_64x39x110: {
      measureReference: {
        textMetric: `110x65 ${cm}`,
        textImperial: '43 1/4x25 5/8 "',
      },
    },
    section_84x54x190_white: {
      measureReference: {
        textMetric: `190x85 ${cm}`,
        textImperial: '74 3/4x33 1/2 "',
      },
    },
    section_84x39x190_white: {
      measureReference: {
        textMetric: `190x85 ${cm}`,
        textImperial: '74 3/4x33 1/2 "',
      },
    },
    section_64x54x190_white: {
      measureReference: {
        textMetric: `190x65 ${cm}`,
        textImperial: '74 3/4x25 5/8 "',
      },
    },
    section_64x39x190_white: {
      measureReference: {
        textMetric: `190x65 ${cm}`,
        textImperial: '74 3/4x25 5/8 "',
      },
    },
    section_84x54x110_white: {
      measureReference: {
        textMetric: `110x85 ${cm}`,
        textImperial: '43 1/4x33 1/2 "',
      },
    },
    section_84x39x110_white: {
      measureReference: {
        textMetric: `110x85 ${cm}`,
        textImperial: '43 1/4x33 1/2 "',
      },
    },
    section_64x54x110_white: {
      measureReference: {
        textMetric: `110x65 ${cm}`,
        textImperial: '43 1/4x25 5/8 "',
      },
    },
    section_64x39x110_white: {
      measureReference: {
        textMetric: `110x65 ${cm}`,
        textImperial: '43 1/4x25 5/8 "',
      },
    },
  };
}

export function setArticles(newArticles) {
  for (const article of newArticles) {
    articles[article.content.ruItemNo] = article;
    articles[article.content.itemNoGlobal] = article;
  }
}

function getArticle(id) {
  // drop trailing 'b' from product variants to enable article matching
  if (/^\d+\w$/.test(id)) {
    id = id.replace(/b$/, '');
  }

  // drop leading 'S' from product ids to enable spr matching
  id = id.replace(/^S(?=\d)/i, '');

  if (articles[id]) {
    return articles[id];
  }

  const sections = getSections();
  if (sections[id]) {
    return sections[id];
  }

  return {};
}

export const getArticleContent = id => {
  return getArticle(id)?.content;
};

export const findArticle = id => {
  let art = getArticleContent(id);
  const includedArticles = productService.getIncludedArticles(id);
  while (includedArticles.length && (!art || !art.measureReference)) {
    art = getArticleContent(includedArticles.shift());
  }

  return art;
};

export default {
  getArticle,
  getArticleContent,
};
